// Modules
import gtm from '@modules/gtm';

/**
 * Loads modules required for the main content matrix
 */

import { loadModulesWhenInView } from '@helpers/loadModule';

export default function init(): void {
  // Load required modules immediately
  gtm();

  // Load optional modules when in view
  loadModulesWhenInView([
    {
      selector: '.js-accordion-group',
      importer: () => import('@modules/accordion'),
    },
    {
      selector: '.js-map',
      importer: () => import('@modules/mapbox'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/vendorStyles'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/formieCsrf'),
    },
    {
      selector: '.js-social-share-button',
      importer: () => import('@modules/socialShare'),
    },
    {
      selector: '.js-swiper',
      importer: () => import('@modules/swiper'),
    },
    {
      selector: '.js-video-container',
      importer: () => import('@modules/video'),
    },
  ]);
}
